import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 8, viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M1.41 -7.62939e-08L6 4.59L10.59 -7.62939e-08L12 1.42L6 7.42L0 1.42L1.41 -7.62939e-08Z", fill: "#E5E4FA" }));
const ForwardRef = forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
